/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%] {\n  display: none;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9henAvYWdlbnQvX3dvcmsvNi9zL2xpYnMvcGFzLWNvbW1vbi9zcmMvbGliL2R1bW15L2R1bW15LmNvbXBvbmVudC5zY3NzIiwibGlicy9wYXMtY29tbW9uL3NyYy9saWIvZHVtbXkvZHVtbXkuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0FDQ0YiLCJmaWxlIjoibGlicy9wYXMtY29tbW9uL3NyYy9saWIvZHVtbXkvZHVtbXkuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG4iLCI6aG9zdCB7XG4gIGRpc3BsYXk6IG5vbmU7XG59Il19 */"];
export { styles as styles };
